<template>
  <div
    class="textSlide-title vertical layout center center-justified"
    :class="{'textSlide-presenting': $store.getters.isPresenting}"
  >
    <SlideTitleEditor
      :class="classHeading"
      class="textSlide-heading"
      type="slide-title"
    />

    <p class="textSlide-subheading" :class="classSubheading" @click="_editSubheading">
      <span
        v-if="slideActive.subheading"
        :inner-html.prop="slideActive.subheading | sanitize(true)"
      />
      <span v-if="!slideActive.subheading && !isPresenting">{{ defaultSubheading }}</span>
    </p>

    <!-- <div class="audio-control-slide" v-if="isShowAudio">
      <AudioControl />
    </div> -->
  </div>
</template>
<script>
import { setTimeout } from 'timers'
import { mapState, mapActions, mapGetters } from 'vuex'
import utils from '@/util'
// import AudioControl from '@/components/presentations/AudioControl'
import SlideTitleEditor from '@/components-v2/presentation-editor/middle/SlideTitleEditor.vue'
import configs from '@/config'

export default {
  components: {
    // AudioControl,
    SlideTitleEditor,
  },
  data() {
    return {
      classHeading: '',
      classSubheading: '',
      // isShowAudio: false,
      mceEditorKey: configs.mceEditorKey,
      headingLimit: 300,
    }
  },
  computed: {
    ...mapGetters(['isPresenting', 'isBackstage']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    defaultSubheading() {
      return 'You can use this Subheading section to explain your point in detail. If the Heading is a quote or a statement of fact, you can put the source of that quote or fact here.'
    },
  },
  watch: {
    '$store.state.slideActive': function watchSlideActive() {
      this._setClassFontSize()
      // this.isShowAudio = this._checkShowAudio()
    },
  },
  mounted() {
    this._setClassFontSize()
    // this.isShowAudio = this._checkShowAudio()
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncLoadingAction']),

    // _checkShowAudio() {
    //   if (this.$store.state.slideActive.id && this.$store.state.slideActive.audioLink) {
    //     return true
    //   }
    //   return false
    // },
    _setClassFontSize() {
      if (this.$store.state.slideActive.title) {
        // title && subheading
        this.classHeading = 'heading-md-title'
        this.classSubheading = 'subheading-md-title'
        if (
          this.slideActive.title.length >= 70 &&
          this.slideActive.title.length <= 110
        ) {
          this.classHeading = 'heading-sm-title'
          this.classSubheading = 'subheading-sm-title'
        } else if (this.slideActive.title.length > 110 && this.slideActive.title.length <= 180) {
          this.classHeading = 'heading-xs-title'
          this.classSubheading = 'subheading-xs-title'
        } else if (this.slideActive.title.length > 180) {
          this.classHeading = 'heading-2xs-title'
          this.classSubheading = 'subheading-2xs-title'
        }
      } else {
        //! title
        this.classHeading = 'heading-sm-title'
        this.classSubheading = 'subheading-md-title'
        //! title && subheading
        if (this.$store.state.slideActive.subheading) {
          if (
            this.$store.state.slideActive.subheading.length >= 70 &&
            this.$store.state.slideActive.subheading.length <= 110
          ) {
            this.classSubheading = 'subheading-sm-title'
          } else if (this.$store.state.slideActive.subheading.length > 110) {
            this.classSubheading = 'subheading-xs-title'
          }
        } else {
          //! title && !subheading
          this.classSubheading = 'subheading-sm-title'
        }
      }
    },
    _editSubheading() {
      if (this.$store.getters.isPresenting) return

      if (this.slideActive.activeTab != 2) {
        this.updateSlideActiveAction({
          activeTab: 2,
        })
      }
      setTimeout(() => {
        const subheading = document.getElementById('subheading-slide-edit')
        if (!subheading) return
        if (subheading.classList.contains('input-focus')) {
          subheading.classList.remove('input-focus')
        }
        subheading.focus()
        subheading.classList.add('input-focus')
      }, 100)
      utils.gaTrackEvent(
        'Slide',
        'Edit text slide',
        'Start editing subheading on preview screen',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.textSlide-title {
  margin: 0 auto;
  text-align: center;
  height: 100%;
  position: relative;
  padding: 0 40px;
  .textSlide-heading {
    padding-bottom: 15px;
    font-weight: bold;
    cursor: pointer;
    backface-visibility: hidden;
    word-break: break-word;
    line-height: 1.2;
  }
  .textSlide-subheading {
    white-space: pre-line;
    overflow-y: auto;
    overflow-x: hidden;
    width: 80%;
    word-break: break-word;
    cursor: pointer;
    opacity: 0.85;
    word-break: break-word;
  }
}
.textSlide-presenting {
  .textSlide-title {
    padding-bottom: 50px;
  }
  .textSlide-heading, .textSlide-subheading {
    cursor: default;
  }
}
</style>
